import LegalPageLayout from "@/components/LegalPageLayout";
import usePageMeta from "@/hooks/usePageMeta";

const SUPPORT_EMAIL = "info@mayr-technologies.com";

const SectionCard = ({ heading, children }) => (
  <section className="rounded-2xl border border-white/[0.08] bg-white/[0.02] p-6 md:p-7">
    <h2 className="font-['Outfit'] text-xl md:text-2xl tracking-tight text-white">
      {heading}
    </h2>
    <div className="mt-3 font-['Manrope'] text-sm md:text-base leading-relaxed text-neutral-400 max-w-3xl">
      {children}
    </div>
  </section>
);

const TermsPage = () => {
  usePageMeta(
    "Terms of Service | Mayr Technologies",
    "Read the Terms of Service for using the Mayr Technologies website, platforms, and related services.",
  );

  return (
    <LegalPageLayout
      title="Terms of Service"
      intro="These Terms of Service govern your use of the website, services, platforms, and related offerings provided by Mayr Technologies."
    >
      <SectionCard heading="Acceptance of Terms">
        <p>
          By accessing or using our website or services, you agree to these Terms of Service. If you do not agree, do not use our website or services.
        </p>
      </SectionCard>

      <SectionCard heading="Use of Services">
        <p>
          You agree to use our website and services only for lawful purposes and in a manner that does not interfere with the operation, security, or integrity of our systems or services.
        </p>
      </SectionCard>

      <SectionCard heading="Intellectual Property">
        <p>
          All content, branding, designs, text, graphics, software, and related materials provided by Mayr Technologies are owned by or licensed to Mayr Technologies unless otherwise stated. You may not copy, reproduce, distribute, or exploit them without permission.
        </p>
      </SectionCard>

      <SectionCard heading="Service Availability">
        <p>
          We may update, modify, suspend, or discontinue parts of our website or services at any time without notice.
        </p>
      </SectionCard>

      <SectionCard heading="No Warranty">
        <p>
          Our website and services are provided on an "as is" and "as available" basis without warranties of any kind, to the fullest extent permitted by law.
        </p>
      </SectionCard>

      <SectionCard heading="Limitation of Liability">
        <p>
          To the fullest extent permitted by law, Mayr Technologies will not be liable for any indirect, incidental, consequential, special, or punitive damages arising from or related to the use of our website or services.
        </p>
      </SectionCard>

      <SectionCard heading="Third-Party Services">
        <p>
          Our services may integrate with or rely on third-party providers. We are not responsible for the independent acts, omissions, or policies of third-party services.
        </p>
      </SectionCard>

      <SectionCard heading="Changes to Terms">
        <p>
          We may update these Terms of Service from time to time. Continued use of our website or services after updates constitutes acceptance of the revised Terms.
        </p>
      </SectionCard>

      <SectionCard heading="Contact">
        <p>Mayr Technologies</p>
        <p className="mt-2">
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="text-neutral-200 underline decoration-white/30 underline-offset-4 transition-colors hover:text-white"
          >
            {SUPPORT_EMAIL}
          </a>
        </p>
        <p className="mt-2">
          <a
            href="https://mayr-technologies.com"
            className="text-neutral-200 underline decoration-white/30 underline-offset-4 transition-colors hover:text-white"
          >
            https://mayr-technologies.com
          </a>
        </p>
      </SectionCard>

      <p className="pt-2 text-xs md:text-sm text-neutral-500 font-['Manrope']">Last updated: March 2026</p>
    </LegalPageLayout>
  );
};

export default TermsPage;
